<script>
	export let columnCount = 1
</script>

<div class="formRow" style={`--formRow-column-count: ${columnCount}`}>
	<slot />
</div>
